import React from "react";

const ArrowRightActive = (props) => {
	return (
		<svg
			width="31"
			height="30"
			viewBox="0 0 31 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				width="30"
				height="30"
				rx="15"
				transform="matrix(-1 0 0 1 30.5 0)"
				fill="url(#paint0_linear_4836_150452)"
			/>
			<path
				d="M13.5 10L18.5781 14.2318C19.0579 14.6316 19.0579 15.3684 18.5781 15.7682L13.5 20"
				stroke="#EFF0F6"
				stroke-width="2"
				stroke-linecap="round"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_4836_150452"
					x1="15"
					y1="0"
					x2="15"
					y2="30"
					gradientUnits="userSpaceOnUse">
					<stop stop-color="var(--stop-color-first)" />
					<stop
						offset="1"
						stop-color="var(--stop-color-second)"
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ArrowRightActive;
